// Kept apart from the map component so the Stimulus controller can import it without pulling in Leaflet

/** Fired by content_browse_controller after every search or country change on /travel */
export const TRIPS_FILTER_EVENT = 'trips:filter';

export interface TripsFilterDetail {
  /** Slugs of the guides that match, or null when nothing is filtered */
  slugs: string[] | null;
}
